import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  {
    q: "What is final expense insurance?",
    a: "Final expense insurance is a whole-life policy designed to cover end-of-life costs such as funeral services, burial or cremation, headstone, medical bills, and small outstanding debts — so your family isn't burdened financially during a difficult time."
  },
  {
    q: "Do I need a medical exam to qualify?",
    a: "No. Our policies do not require a medical exam. You'll simply answer a few health questions on the application. Guaranteed-issue plans accept everyone in the qualifying age range, regardless of health history."
  },
  {
    q: "How much coverage do I need?",
    a: "Most families choose between $10,000 and $25,000. The national median funeral cost is around $9,000, but you may want extra coverage for medical bills, travel costs for loved ones, or a small inheritance. Our agents will help you decide."
  },
  {
    q: "Will my premium ever increase?",
    a: "No. Your premium is locked in the day your policy is issued and will never increase, even as you age or your health changes."
  },
  {
    q: "When does coverage begin?",
    a: "Most policies are active as soon as your first premium is paid — often within 24 hours of approval. Some guaranteed-issue plans have a 2-year graded benefit period for natural causes; accidental death is covered immediately."
  },
  {
    q: "What ages qualify?",
    a: "We offer coverage to U.S. residents ages 50 to 85. Some carriers extend acceptance up to age 89 depending on the plan."
  },
  {
    q: "Is the death benefit paid quickly?",
    a: "Yes. Claims are typically paid to your named beneficiary within 24–72 hours of receiving the death certificate, so funds are available when your family needs them."
  },
  {
    q: "Can I cancel my policy if I change my mind?",
    a: "Absolutely. Every policy includes a 30-day 'free look' period — if you cancel within 30 days, you receive a 100% refund of any premiums paid."
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-20 lg:py-28 bg-white" data-testid="faq-section">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div>
          <p className="text-xs sm:text-sm uppercase tracking-[0.22em] text-gold-deep font-semibold">Frequently Asked</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-navy leading-tight mt-3">
            Your Questions, Answered Plainly.
          </h2>
          <div className="accent-line mt-5" />
        </div>

        <Accordion type="single" collapsible className="mt-10" data-testid="faq-accordion">
          {FAQS.map((item, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-border">
              <AccordionTrigger
                data-testid={`faq-question-${i}`}
                className="font-serif text-lg sm:text-xl text-navy text-left py-5 hover:no-underline"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-answer-${i}`}
                className="text-navy/75 text-base leading-relaxed pb-6 pr-6"
              >
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
